"use strict";
var compile = require('cwise-compiler');
var EmptyProc_1 = require('./EmptyProc');
function fixup(x) {
    if (!x) {
        return EmptyProc_1.default;
    }
    for (var i = 0; i < x.args.length; ++i) {
        var a = x.args[i];
        if (i === 0) {
            x.args[i] = { name: a, lvalue: true, rvalue: !!x.rvalue, count: x.count || 1 };
        }
        else {
            x.args[i] = { name: a, lvalue: false, rvalue: true, count: 1 };
        }
    }
    if (!x.thisVars) {
        x.thisVars = [];
    }
    if (!x.localVars) {
        x.localVars = [];
    }
    return x;
}
function pcompile(user_args) {
    return compile({
        args: user_args.args,
        pre: fixup(user_args.pre),
        body: fixup(user_args.body),
        post: fixup(user_args.proc),
        funcName: user_args.funcName
    });
}
function makeOp(user_args) {
    var args = [];
    for (var i = 0; i < user_args.args.length; ++i) {
        args.push("a" + i);
    }
    var wrapper = new Function("P", [
        "return function ", user_args.funcName, "_ndarrayops(", args.join(","), ") {P(", args.join(","), ");return a0}"
    ].join(""));
    return wrapper(pcompile(user_args));
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = makeOp;
//# sourceMappingURL=makeOp.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/~/@voxeline/mesher/~/ndarray-ops-typed/lib/makeOp.js
 ** module id = 945
 ** module chunks = 0
 **/